export const validation = {
  required: "Required field",
  number: "Must be a number",
  numberPositive: "Number must be positive",
  numberInteger: "Number must be an integer",
};
